<template>
  <div class="learn-ability-test-header">
    <div class="learn-ability-test-header-container">
      <img v-if="type === 'start'"
           class="learn-ability-test-header-gear-deco"
           :src="require('@/pages/2020/LearnAbilityTest/assets/img/gear_icon.png')"
      />
      <div v-else-if="type === 'end'"
           class="learn-ability-test-header-test-done"
      >
        <img class="learn-ability-test-header-test-done-icon"
             :src="require('@/pages/2020/LearnAbilityTest/assets/img/result_icon.png')"
        />
        <span>恭喜您完成30道测试题</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LearnAbilityTestHeader',
    props: {
      type: {
        type: String,
        validator(val) {
          return [
            'start',
            'end',
          ].includes(val);
        },
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .learn-ability-test-header {
    box-sizing: border-box;
    width: 100%;
    padding-bottom: 110px;

    &-container {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 280px;
      padding: 50px 0 60px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: @color-white;
      font-size: 42px;
      font-weight: 500;
      background: linear-gradient(to right, #5757ec, #3c3cda);
      border-radius: 0 0 50px 50px;
    }
    &-gear-deco {
      position: absolute;
      bottom: -110px;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 110px;
      height: 296px;
    }
    &-test-done {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    &-test-done-icon {
      flex-shrink: 0;
      display: block;
      width: 122px;
      height: 122px;
    }
  }

</style>
